/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RoomPreferencesSettingsQueryVariables = {
    queryInput: string;
    orgRelayId: string;
    excludeCalendars: Array<string>;
};
export type RoomPreferencesSettingsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"RoomPreferencesSettings_viewer">;
    };
};
export type RoomPreferencesSettingsQuery = {
    readonly response: RoomPreferencesSettingsQueryResponse;
    readonly variables: RoomPreferencesSettingsQueryVariables;
};



/*
query RoomPreferencesSettingsQuery(
  $queryInput: String!
  $orgRelayId: ID!
  $excludeCalendars: [String!]!
) {
  viewer {
    ...RoomPreferencesSettings_viewer_1L0Few
    id
  }
}

fragment RoomPreferencesSettings_viewer_1L0Few on Viewer {
  roomQueryResult(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {
    __typename
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on ExternalRoomSearchResult {
      searchQuery
      cacheable
      rooms {
        roomId
        name
        orgId
        estimatedCapacity
        reportedCapacity
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeCalendars"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryInput"
    } as any, v3 = {
        "kind": "Variable",
        "name": "excludeCalendars",
        "variableName": "excludeCalendars"
    } as any, v4 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "RoomPreferencesSettingsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "queryInput",
                                    "variableName": "queryInput"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "RoomPreferencesSettings_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "RoomPreferencesSettingsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "query",
                                    "variableName": "queryInput"
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "roomQueryResult",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "statusCode",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GraphEntityError",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "searchQuery",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cacheable",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Room",
                                            "kind": "LinkedField",
                                            "name": "rooms",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "roomId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "orgId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "estimatedCapacity",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "reportedCapacity",
                                                    "storageKey": null
                                                },
                                                (v5 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "ExternalRoomSearchResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "df28d8ef6aee07ce6b607ccefaeff2db",
            "id": null,
            "metadata": {},
            "name": "RoomPreferencesSettingsQuery",
            "operationKind": "query",
            "text": "query RoomPreferencesSettingsQuery(\n  $queryInput: String!\n  $orgRelayId: ID!\n  $excludeCalendars: [String!]!\n) {\n  viewer {\n    ...RoomPreferencesSettings_viewer_1L0Few\n    id\n  }\n}\n\nfragment RoomPreferencesSettings_viewer_1L0Few on Viewer {\n  roomQueryResult(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on ExternalRoomSearchResult {\n      searchQuery\n      cacheable\n      rooms {\n        roomId\n        name\n        orgId\n        estimatedCapacity\n        reportedCapacity\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '13ce63defbccaa0fb8d7cccba6a420da';
export default node;
